import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import 'hammerjs';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    if (!environment.production) {
      // tslint:disable-next-line:no-console
      console.log(err);
    }
  });



// WEBPACK FOOTER //
// ./src/main.ts